import { Copy } from 'lucide-react';

import { IconButton } from '../../components/IconButton';
import { useToast } from '../../components/Toast';
import { publicApiCurlUrl, publicApiUrl } from '../../lib/apiUrl';
import { cn } from '../../lib/cn';
import styles from './SettingsPages.module.css';

/**
 * Справка «куда обращаться по API» (docs/12 §2.3, docs/06 §3.6).
 *
 * Внешней системе нужен полный адрес вида `https://tasks.example.ru/api/v1`,
 * а не только префикс: администратор копирует эту строку и отправляет её
 * интегратору. Хост берётся из адресной строки, а не из конфига фронтенда:
 * справка обязана показывать ту среду, в которой открыт интерфейс, иначе
 * скопированный адрес уведёт интеграцию на dev или прод по ошибке.
 */
export function ApiBaseUrlHint() {
  const toast = useToast();
  const origin = window.location.origin;
  const baseUrl = publicApiUrl(origin);

  const copy = (): void => {
    void navigator.clipboard.writeText(baseUrl).then(
      () => toast.success('Адрес API скопирован'),
      () => toast.error('Не удалось скопировать'),
    );
  };

  return (
    <section className={styles['section']}>
      <div className={styles['sectionHeader']}>
        <h2>Адрес API</h2>
      </div>

      <p className={styles['hint']}>
        Полный путь для обращения по API: хост этой среды и версия в пути. Cookie-сессия здесь не
        работает — только заголовок <code>Authorization: Bearer</code> с токеном проекта.
      </p>

      <div className={styles['apiBaseRow']}>
        <code className={cn('u-mono', styles['apiBaseValue'])} data-testid="api-base-url">
          {baseUrl}
        </code>
        <IconButton
          size="sm"
          label="Скопировать адрес API"
          icon={<Copy size={14} />}
          onClick={copy}
        />
      </div>

      <p className={styles['hint']}>
        Например, проверка токена: <code>GET {publicApiCurlUrl(origin)}</code>. Руководство по всем
        методам — в файле ниже.
      </p>
    </section>
  );
}
